<template>
    <ul>
        <li :id="item.htmlId" :class="item.htmlClass" v-for="item in allowedItems"
            @click.self="$el.classList.toggle('active')">
            <a v-if="item.url" :href="item.url" :target="item.htmlTarget">
                <span>{{ item.title }}</span>
            </a>
            <router-link v-else-if="item.pageUrl" :to="item.pageUrl" :target="item.htmlTarget">
                <span>{{ item.title }}</span>
            </router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: "MenuWithoutIcons",

    props: ['items'],

    computed: {
        allowedItems() {
            return this.items || [];
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/menus/MenuWithoutIcons"
</style>